import { Input } from '../../../components/ui/input';
import { cn } from '../../../lib/utils';
import type { DateRange } from '../../../lib/reportingDateRange';
import { SOCIAL_PERIOD_OPTIONS, type SocialPeriodPreset } from './socialPeriod';

// Organic Social Reporting — period selector. This Month / Last Month / Past 7 /
// Past 30 / Custom, each vs its comparable previous window (see socialPeriod.ts).
// Custom reveals two date inputs.
export function SocialPeriodSelector({
  preset,
  custom,
  onPresetChange,
  onCustomChange,
}: {
  preset: SocialPeriodPreset;
  custom: DateRange;
  onPresetChange: (preset: SocialPeriodPreset) => void;
  onCustomChange: (range: DateRange) => void;
}) {
  return (
    <div className="flex flex-wrap items-center gap-3">
      <div className="inline-flex rounded-md border border-slate-200 bg-white p-0.5">
        {SOCIAL_PERIOD_OPTIONS.map((opt) => (
          <button
            key={opt.value}
            type="button"
            onClick={() => onPresetChange(opt.value)}
            className={cn(
              'rounded px-3 py-1.5 text-sm font-medium transition-colors',
              preset === opt.value
                ? 'bg-kyck-50 text-slate-900'
                : 'text-slate-600 hover:bg-slate-50',
            )}
          >
            {opt.label}
          </button>
        ))}
      </div>

      {preset === 'custom' && (
        <div className="flex items-center gap-2">
          <Input
            type="date"
            value={custom.from}
            max={custom.to}
            onChange={(e) => onCustomChange({ ...custom, from: e.target.value })}
            className="w-40"
          />
          <span className="text-sm text-slate-400">→</span>
          <Input
            type="date"
            value={custom.to}
            min={custom.from}
            onChange={(e) => onCustomChange({ ...custom, to: e.target.value })}
            className="w-40"
          />
        </div>
      )}
    </div>
  );
}
